<template>
  <div id="primary-nav">
    <b-container class="primary-nav-container">
      <span class="logo" v-scroll-to="{ el: '#landing', offset: -75 }"
        >g.dev</span
      >
      <b-nav class="nav-links" v-b-scrollspy="500">
        <b-nav-item
          class="nav-link"
          v-for="(link, index) in primaryLinks"
          :key="'nav' + index"
          :href="link.anchor"
          v-scroll-to="{ el: link.anchor, offset: -75 }"
        >
          <span> {{ link.title }}</span>
        </b-nav-item>
      </b-nav>
      <img
        @click="setModalData({ modalType: 'settings' })"
        class="gear"
        alt="settings"
        :src="
          global.darkMode
            ? require('@/assets/images/icons/gear-blue.png')
            : require('@/assets/images/icons/gear-orange.png')
        "
      />
    </b-container>
  </div>
</template>

<script>
import { navData } from "@/data/navData";
import { analyticsHelper } from "@/helpers";
import { mapState, mapActions } from "vuex";
export default {
  name: "PrimaryNav",
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      primaryLinks: navData(),
      analyticsHelper,
    };
  },
  mounted() {
    this.$root.$on("bv::scrollspy::activate", this.analyticsHelper.scrollTo);
  },
  methods: {
    ...mapActions(["setModalData"]),
  },
};
</script>

<style lang="scss" scoped>
#primary-nav {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding-right: env(safe-area-inset-right);
  padding-left: env(safe-area-inset-left);
  .primary-nav-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: $xl) {
    .container {
      margin: 0;
      width: 100%;
      max-width: 100%;
    }
  }
  .gear {
    height: 35px;
    width: 35px;
  }

  .logo {
    font-size: 25px;
    max-height: 80px;
    margin-right: 80px;
    font-family: $font-header;
    color: $lt-secondary-color;
    cursor: pointer;
  }

  .nav-links {
    display: flex;
    height: 100%;
    flex-direction: row;
    background: transparent;
    align-items: center;
    justify-content: flex-start;
    flex: 1;

    @media (max-width: $lg) {
      padding-left: 0;
      justify-content: flex-end;
    }
    .highlight {
      height: 4px;
      width: 100%;
      opacity: 0;
      background: #eaeaea;
      transition: all 250ms ease-in;
    }
    .active {
      span {
        color: $lt-secondary-color !important;
      }
    }
    .nav-link {
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &:first-child {
        padding-left: 0;
      }
      @media (max-width: $lg) {
        padding-left: 10px;
        padding-right: 10px;
      }
      span {
        font-family: $font-primary;
        font-size: 16px;
        color: #000;
        letter-spacing: 0;
        text-align: left;
        line-height: 20px;
        text-transform: uppercase;
      }
      &:hover {
        cursor: pointer;
        .highlight {
          opacity: 1;
        }
      }
    }
    .nav-link,
    .nav-link:hover {
      text-decoration: none !important;
    }
  }
}
</style>







<style lang="scss">
.dark {
  #primary-nav {
    background: $dt-bg-color;
    .logo {
      color: $dt-secondary-color;
    }
    .nav-links {
      .highlight {
        background: #eaeaea;
      }
      .active {
        span {
          color: $dt-secondary-color !important;
        }
      }
      .nav-link {
        span {
          color: $dt-font-color;
        }
      }
    }
  }
}
</style>

